var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsNumber, IsObject, IsString, ValidateNested } from 'class-validator';
import { TaskScopeDto } from '../../treatment-plan-detail/dto/treatment-plan-task-view.dto.js';
/** What one appointment still needs from its therapist — appointment-scoped TaskRules. */
export const APPOINTMENT_TASK_IDS = [
    'attendance_unconfirmed',
    'documentation_missing',
    'delivery_fact_missing',
];
export class AppointmentTaskViewDto {
    id;
    /** `critical` | `warning` | `info` | `done` — done tasks are included for checklist surfaces. */
    severity;
    // Plain pass-through, as on TreatmentPlanTaskViewDto: a discriminated union
    // keyed on `id` that class-transformer cannot narrow.
    params;
    scope;
    occurrenceKey;
    ruleVersion;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AppointmentTaskViewDto.prototype, "id", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AppointmentTaskViewDto.prototype, "severity", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentTaskViewDto.prototype, "params", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => TaskScopeDto),
    Expose(),
    __metadata("design:type", TaskScopeDto)
], AppointmentTaskViewDto.prototype, "scope", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AppointmentTaskViewDto.prototype, "occurrenceKey", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], AppointmentTaskViewDto.prototype, "ruleVersion", void 0);
//# sourceMappingURL=appointment-task-view.dto.js.map